/**
 * get a number in the range [start, end]
 * @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
 * @param {number} end
 * @param {number} start
 */
export const randomInteger = (end, start = 0) => {
  if (end < start) return 0;
  const min = Math.ceil(start);
  const max = Math.floor(end);
  return min + Math.floor(Math.random() * (max - min + 1));
};

/**
 * Modified Fisher-Yates shuffle for picking k elements from an array
 * @link https://en.wikipedia.org/wiki/Reservoir_sampling#Relation_to_Fisher%E2%80%93Yates_shuffle
 * @param {Array} A an array
 * @param {number} k how many to pick
 * @return {Array} B such that B is a subset of A with k elements
 */
export const sample = (A = [], k = 0) => {
  const B = A.slice(0, k);
  for (let i = k; i < A.length; i += 1) {
    const j = randomInteger(i);
    if (j < k) {
      B[j] = A[i];
    }
  }
  return B;
};

/**
 * Fisher-Yates shuffle
 * @link https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
 * @link https://blog.codinghorror.com/the-danger-of-naivete/
 * @param {Array} A an array
 * @return {Array} a subset of A
 */
export const shuffle = (A = []) => {
  const B = [];
  for (let i = 0; i < A.length; i += 1) {
    const j = randomInteger(i);
    if (j !== i) {
      B[i] = B[j];
    }
    B[j] = A[i];
  }
  return B;
};

/**
 * @param {Array} A an array
 * @return {Array} B such that B is a subset of A
 */
export const randomSubArray = (A = []) => {
  const B = [];
  for (let index = 0; index < A.length; index += 1) {
    const element = A[index];
    if (Math.random() > 0.5) {
      B.push({ ...element });
    }
  }
  return B;
};

export default { sample, randomInteger, shuffle, randomSubArray };
